(() => {
  // src/lib/ensure-stylesheet.ts
  var loaded = /* @__PURE__ */ new Set();
  var ensureStylesheet = (href) => new Promise((resolve) => {
    if (loaded.has(href) || document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
      loaded.add(href);
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => {
      loaded.add(href);
      resolve();
    };
    link.onerror = () => resolve();
    document.head.appendChild(link);
  });
  var hoistAndAwaitStylesheets = async (doc) => {
    const links = Array.from(doc.querySelectorAll('link[rel="stylesheet"]'));
    await Promise.all(links.map((l) => ensureStylesheet(l.href)));
    links.forEach((l) => l.remove());
  };

  // src/lib/upsell-debug.ts
  var isUpsellDebug = () => {
    var _a;
    if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) return true;
    try {
      return new URLSearchParams(window.location.search).get("rebuy_debug") === "1";
    } catch (e) {
      return false;
    }
  };

  // src/recommendation-shopify-provider.ts
  (() => {
    var _a, _b;
    window.HotelCollection = window.HotelCollection || {};
    const log = (...args) => {
      if (isUpsellDebug()) console.log("[recs:shopify]", ...args);
    };
    const warn = (...args) => {
      if (isUpsellDebug()) console.warn("[recs:shopify]", ...args);
    };
    const toShopifyIntent = (intent) => intent === "complementary" ? "complementary" : "related";
    const sectionId = (_a = document.querySelector("[data-cart-upsell]")) == null ? void 0 : _a.dataset.cartUpsell;
    window.HotelCollection.ShopifyRecommendationProvider = {
      async fetchHtml({ productId, limit, intent }) {
        var _a2;
        const recommendationType = toShopifyIntent(intent);
        const meta = {
          providerUsed: "shopify",
          recommendationType,
          sourceId: "",
          renderedCount: 0
        };
        if (!sectionId) {
          warn("cart-upsell-recommendations section not on page \u2014 fallback unavailable");
          return { html: "", meta };
        }
        if (!productId) {
          warn("no seed product id \u2014 fallback cannot recommend");
          return { html: "", meta };
        }
        const seedId = String(productId).split(",")[0].trim();
        if (!seedId) {
          warn("no usable seed product id \u2014 fallback cannot recommend");
          return { html: "", meta };
        }
        if (seedId !== String(productId)) {
          log(
            `multiple seed ids received \u2014 Shopify accepts one, using "${seedId}"`,
            productId
          );
        }
        const url = `/recommendations/products?section_id=${encodeURIComponent(
          sectionId
        )}&product_id=${encodeURIComponent(seedId)}&limit=${limit}&intent=${recommendationType}`;
        log("\u2192 Shopify request", { productId: seedId, intent: recommendationType, limit, url });
        const r = await fetch(url);
        if (!r.ok) {
          warn("\u2190 Shopify response error", r.status);
          throw new Error(String(r.status));
        }
        const doc = new DOMParser().parseFromString(await r.text(), "text/html");
        await hoistAndAwaitStylesheets(doc);
        const html = ((_a2 = doc.querySelector("[data-cart-upsell]")) == null ? void 0 : _a2.innerHTML) || "";
        meta.renderedCount = doc.querySelectorAll(".cart-item-upsell").length;
        log(`\u2190 Shopify rendered ${meta.renderedCount} card(s)`);
        return { html, meta };
      }
    };
    (_b = window.HotelCollection.RecommendationEngine) == null ? void 0 : _b.setFallbackProvider(
      window.HotelCollection.ShopifyRecommendationProvider
    );
  })();
})();
